import { render } from "./Filters.vue?vue&type=template&id=10b7dce4&scoped=true&ts=true"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"

import "./Filters.vue?vue&type=style&index=0&id=10b7dce4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b7dce4"]])

export default __exports__